import {
  Article as ZinniaArticle,
  ArticleProps as ZinniaArticleProps,
  ArticleDate,
  ArticleMeta,
  ArticleReadTime,
} from '@zapier/design-system';
import md5 from 'md5';
import { COLOR_KEYS } from '../../constants';
import { RichTextHtml } from '../RichTextHtml/RichTextHtml';
import { RichTextHTMLString } from '../sections/types';

export interface ArticleProps
  extends Omit<ZinniaArticleProps, 'author' | 'description' | 'meta' | 'size'> {
  authorEmail?: string;
  authorImageUrl?: string;
  authorName: string;
  description?: RichTextHTMLString;
  metaDate?: string;
  metaReadTime?: number;
}

export function Article(props: ArticleProps) {
  const getGravatarUrl = () => {
    return (
      props.authorEmail &&
      'https://www.gravatar.com/avatar/' +
        md5(props.authorEmail) +
        '?d=https://secure.gravatar.com/avatar/b9fa8353122853002d8dcffc2c775182'
    );
  };

  return (
    <ZinniaArticle
      author={{
        name: props.authorName,
        imageUrl: props.authorImageUrl || getGravatarUrl(),
      }}
      category={props.category}
      categoryUrl={props.categoryUrl}
      description={
        props.description && (
          <RichTextHtml
            backgroundColor={COLOR_KEYS.neutral100}
            html={props.description}
          />
        )
      }
      imageUrl={props.imageUrl}
      label={props.label}
      labelIcon={props.labelIcon}
      labelVariant={props.labelVariant}
      layout={props.layout}
      meta={
        (props.metaDate || props.metaReadTime) && (
          <ArticleMeta>
            {props.metaDate && <ArticleDate date={props.metaDate} />}
            {props.metaReadTime && (
              <ArticleReadTime minutes={props.metaReadTime} />
            )}
          </ArticleMeta>
        )
      }
      size="medium"
      title={props.title}
      url={props.url}
    />
  );
}
